import { Controller, UseFormReturn } from 'react-hook-form';
import { FormEditorForm } from '../../../shared';
import { QSwitch } from '@qualio/ui-components';
import * as DisplayStrings from '../../../../../displayStrings';

type Props = {
  control: UseFormReturn<FormEditorForm>['control'];
  fieldIndex: number;
  isDisabled?: boolean;
  isHidden?: boolean;
};

const MultiSwitch = ({ control, fieldIndex, isDisabled = false, isHidden = false }: Props) => {
  return (
    <Controller
      name={`fields.${fieldIndex}.multi`}
      control={control}
      render={({ field }) => {
        const { value, onChange } = field;

        return (
          <QSwitch
            data-cy={`field-multi-${fieldIndex}`}
            isChecked={value}
            onChange={onChange}
            isDisabled={isDisabled}
            style={isHidden ? { display: 'none' } : undefined}
          >
            {DisplayStrings.MultiSelect}
          </QSwitch>
        );
      }}
    />
  );
};

export default MultiSwitch;
